import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// Register Service Worker for PWA — with auto-update on new deploy
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { updateViaCache: 'none' })
      .then((registration) => {
        // Poll for SW updates every 5 minutes so long-lived tabs (the
        // installed PWA on a user's home screen) pick up new deploys
        // without requiring a full app restart.
        setInterval(() => { registration.update().catch(() => {}); }, 5 * 60 * 1000);

        // When a new SW finishes installing AND an old one is controlling
        // the page, prompt the new one to take over immediately.
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch((error) => {
        console.log('QuoteSnapp PWA: Service Worker registration failed:', error);
      });

    // When the controlling SW changes (= a new version just took over),
    // reload exactly once so the user is on fresh JS/CSS. Guarded so we
    // never end up in an infinite reload loop.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });

    // The SW itself broadcasts NEW_VERSION_ACTIVE on activate; treat that
    // as a soft "you're now on the latest" signal (no-op for now, kept
    // for future "you've been updated" toast).
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'NEW_VERSION_ACTIVE') {
        console.info('QuoteSnapp PWA: activated version', event.data.version);
      }
    });
  });
}
